import React, { Fragment, useEffect } from "react";
import {
    message,
    Spin,
} from "antd";
import { connect } from "react-redux";
import qs from 'qs';
import Helmet from "react-helmet";
import { push } from "connected-react-router";
import { Route, Switch, Link } from "react-router-dom";
import {API} from "aws-amplify";
import {sessionActions} from "../../redux/modules/session";

const EtsyCallback = ({ history, dispatch }) => {

    useEffect(() => {
        const query = qs.parse(window.location.search.substr(1));
        if (query.code) {
            API.post("api", "etsy/auth/validate", {
                body: query
            }).then(
                (resp) => {
                    message.success(`${resp.name} successfully connected.`);
                    dispatch(sessionActions.setStore(resp));
                    dispatch(push(`/settings/stores/${resp.storeId}/settings`));
                    dispatch(sessionActions.selectStore(resp.storeId));
                },
                (e) => {
                    message.error(e.response.data.message);
                    history.push('/settings/stores');
                }
            );
        } else {
            history.push('/settings/stores');
        }
    }, []);

    return (
        <div>
            <Helmet title="Etsy setup" />
            <h1>Please wait...</h1>
            <Spin spinning />
        </div>
    )
};

export default connect()(EtsyCallback);